import React, { useState, Fragment } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { useEffect } from "react";
import { getCmsAxios } from "../../Actions/axios";

const AnnouncementList = () => {
  const navigate = useNavigate();
  const [cmsList, setCmsList] = useState([]);

  const getCms = async () => {
    let resp = await getCmsAxios({ slug: "announcement" });
    console.log("🚀 ~ getCms ~ resp:", resp);
    if (resp?.status) {
      setCmsList(resp?.data);
    }
  };

  const columns = [
    {
      name: "S.no",
      align: "left",
      sortable: false,
      selector: (row, i) => <p>{i + 1}</p>,
    },
    {
      name: "Title",
      align: "left",
      sortable: false,
      selector: (row) => <p>{row.title}</p>,
    },
    {
      name: "Content",
      align: "left",
      sortable: false,
      selector: (row) => <p>{row.slug.toUpperCase()}</p>,
    },
    {
      name: "Action",
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className={`btn sitebtn btn-sm ${record._id}`}
              onClick={() => navigate("/cmsEdit", { state: { ...record } })}
            >
              <FaEdit />
            </button>
          </Fragment>
        );
      },
    },
  ];

  useEffect(() => {
    getCms();
  }, []);

  return (
    <div className="cmslist">
      <h1 className="pagehead">Announcement List</h1>
      <div className="cardbox">
        <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
          <Form>
            <Form.Control type="text" placeholder="Search" />
          </Form>
          <Link to="/addannouncement" className="btn sitebtn">
            Add
          </Link>
        </div>
        <div className="tablebox">
          <DataTable
            className="react-datatables"
            columns={columns}
            data={cmsList}
            pagination
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
          />
        </div>
      </div>
    </div>
  );
};

export default AnnouncementList;
